import { apiLocal } from './servers/apiInternal';

export interface Ocorrencia {
  id: number;
  inicio: string;
  termino: string | null;
  titulo: string;
  descricao: string;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
}

export interface CriarOcorrenciaPayload {
  inicio: string;
  termino?: string | null;
  titulo: string;
  descricao: string;
}

export interface AtualizarOcorrenciaPayload {
  termino?: string | null;
  descricao: string;
}

export async function listarOcorrencias(): Promise<Ocorrencia[]> {
  const resp = await apiLocal.get('/ocorrencias');
  return resp.data.data;
}

export async function criarOcorrencia(payload: CriarOcorrenciaPayload): Promise<Ocorrencia> {
  const resp = await apiLocal.post('/ocorrencias', payload);
  return resp.data.data;
}

export async function atualizarOcorrencia(
  id: number,
  payload: AtualizarOcorrenciaPayload,
): Promise<Ocorrencia> {
  const resp = await apiLocal.put(`/ocorrencias/${id}`, payload);
  return resp.data.data;
}

export async function deletarOcorrencia(id: number): Promise<void> {
  await apiLocal.delete(`/ocorrencias/${id}`);
}
